import * as actions from './slice'

const getSkillBiteList = ({ onSuccess }) => ({
  eventName: 'adminSkillBiteList',
  onSuccess: [{ action: actions.getSkillBiteList, redux: true }, onSuccess]
})

const addSkillBiteList = ({ onSuccess }) => ({
  eventName: 'adminSkillBiteList',
  onSuccess: [{ action: actions.addSkillBiteList, redux: true }, onSuccess]
})

export {
  getSkillBiteList,
  addSkillBiteList
}
